import {EventEmitter, Injectable} from '@angular/core';

@Injectable()
export class UserPrivacyService {

  showUserPrivacy = new EventEmitter<boolean>();
  constructor() { }

  showPrivacyRulesPopup(show : boolean) {
    this.showUserPrivacy.emit(show);
  }

}
